import styled, {css} from 'styled-components';

export const Container = styled.button`
    display: flex;
    height: 3.2rem;
    width: 100%;
    border-radius: 10px;
    border: none;
    font-weight: 700;
    color:${({color,theme}) => color ?color :theme.colors.__white};
    background-color:${({backgroundColor,theme}) => backgroundColor ?backgroundColor :theme.colors.__green[200] };
    transition: filter 0.1s;
    transition: all 0.7s ease;
    justify-content: center;
    align-items: center;

    &:hover{
        filter: brightness(0.97);
    }

    ${({ loading }) => loading === 1 &&
        css`
            height: 3.2rem;
            width: 4rem;
            pointer-events: none;
        `
    }

    div {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2rem;
    }

`;


